export default "__VITE_ASSET__BXEajmaP__"